import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import { TRACKING_LINK_CATEGORIES, TRANSLATE_PREFIX } from '../../consts';
import css from './CategoryCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const CATEGORY_BADGE_CLASS = {
    [TRACKING_LINK_CATEGORIES.DEVICE_LEVEL]: css.badgeDeviceLevel,
    [TRACKING_LINK_CATEGORIES.CAMPAIGN]: css.badgeCampaign,
    [TRACKING_LINK_CATEGORIES.PUBLISHER]: css.badgePublisher,
    [TRACKING_LINK_CATEGORIES.OTHER]: css.badgeOther,
    [TRACKING_LINK_CATEGORIES.CUSTOM]: css.badgeCustom,
};

const CATEGORY_LABEL_KEY = {
    [TRACKING_LINK_CATEGORIES.DEVICE_LEVEL]: `${TAB_PREFIX}.FILTER_DEVICE_LEVEL`,
    [TRACKING_LINK_CATEGORIES.CAMPAIGN]: `${TAB_PREFIX}.FILTER_CAMPAIGN`,
    [TRACKING_LINK_CATEGORIES.PUBLISHER]: `${TAB_PREFIX}.FILTER_PUBLISHER`,
    [TRACKING_LINK_CATEGORIES.OTHER]: `${TAB_PREFIX}.FILTER_OTHER`,
    [TRACKING_LINK_CATEGORIES.CUSTOM]: `${TAB_PREFIX}.CUSTOM_MACRO_LABEL`,
};

const CategoryCell = ({ row, onDelete, readOnly }) => {
    const { category, index } = row;
    const canDelete = !readOnly && !row.isPrimary;
    return (
        <td className={css.categoryCell}>
            {canDelete && (
                <Icon
                    name="x"
                    size={IconSizes.X_SMALL}
                    variant={IconVariants.ERROR}
                    className={css.deleteBtn}
                    onClick={() => onDelete(index)}
                />
            )}
            <span className={classNames(css.categoryBadge, CATEGORY_BADGE_CLASS[category])}>
                <Translate id={CATEGORY_LABEL_KEY[category]} />
            </span>
        </td>
    );
};

CategoryCell.propTypes = {
    row: PropTypes.shape({
        category: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        isPrimary: PropTypes.bool.isRequired,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

export default CategoryCell;
